export default __webpack_public_path__ + "static/media/Kanit-Medium.a7e1e17c.ttf";